import { render, staticRenderFns } from "./project-options.html?vue&type=template&id=ecde8524&"
import script from "./ProjectOptions.vue?vue&type=script&lang=js&"
export * from "./ProjectOptions.vue?vue&type=script&lang=js&"
import style0 from "./ProjectOptions.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports